export default "__VITE_ASSET__BxH_5umV__"